<template>
  <div class="circle-section">
    <div class="sec-top">
      <div class="sec-title" v-show="title !== ''">
        <span class="title">{{ title }}</span>
      </div>
      <div class="sec-status">
        <div class="status2">
          <div class="redDot"></div>
          <div class="redTxt">待解决</div>
        </div>
        <div class="status1">
          <div class="greenDot"></div>
          <div class="greenTxt">已解决</div>
        </div>
      </div>
    </div>
    <!--饼状图部分-->
    <div class="sec-content">
      <div class="pie-chart">
        <div class="chart-sec">
          <v-chart
            ref="chart1"
            :options="barOptionthisweek"
            style="width: 1.1rem; height: 1.1rem"
          ></v-chart>
        </div>
        <div class="chart-txt">本周发现缺陷</div>
      </div>
      <div class="pie-chart">
        <div class="chart-sec">
          <v-chart
            ref="chart2"
            :options="barOptionlastweek"
            style="width: 1.1rem; height: 1.1rem"
          ></v-chart>
        </div>
        <div class="chart-txt">上周整改完成情况</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "CircleCharts", // 商机状态
  components: {},
  props: {
    title: {
      // 投资成本金额标题
      type: String,
      default: "质量统计",
    },
    circleChartsData: {
      type: Object,
    },
  },
  data() {
    return {
      barOptionthisweek: {
        color: [
          "rgba(123, 211, 198, 1)",
          "rgba(221, 82, 82, 1)",
          "rgba(212, 218, 223, 0.1)",
        ],
        title: {
          text: "",
          left: "center",
          bottom: "35%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: this.$common.fitChartSize(18),
            fontWeight: 300,
          },
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        series: [
          {
            type: "pie",
            radius: ["70%", "90%"],
            itemStyle: {
              borderRadius: 0,
              borderColor: "#000",
              borderWidth: 0,
            },
            hoverAnimation: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              scale: false,
              label: {
                show: true,
                color: "#fff",
                fontSize: "16",
                fontWeight: "normal",
                formatter: "",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
          // {
          //   name: "外边框",
          //   type: "pie",
          //   clockWise: false, //顺时加载
          //   hoverAnimation: false, //鼠标移入变大
          //   center: ["50%", "50%"],
          //   radius: ["90%", "70%"],
          //   label: {
          //     normal: {
          //       show: false,
          //     },
          //   },

          //   data: [
          //     {
          //       value: 1,
          //       name: "",
          //       itemStyle: {
          //         normal: {
          //           borderWidth: 0,
          //           borderColor: "#2985e0",
          //         },
          //       },
          //     },
          //   ],
          // },
        ],
      },
      barOptionlastweek: {
        color: [
          "rgba(123, 211, 198, 1)",
          "rgba(221, 82, 82, 1)",
          "rgba(212, 218, 223, 0.1)",
        ],
        title: {
          text: "",
          left: "center",
          bottom: "35%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: this.$common.fitChartSize(18),
            fontWeight: 300,
          },
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        series: [
          {
            type: "pie",
            radius: ["70%", "90%"],
            itemStyle: {
              borderRadius: 0,
              borderColor: "#000",
              borderWidth: 0,
            },
            hoverAnimation: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              scale: false,
              label: {
                show: true,
                color: "#fff",
                fontSize: "16",
                fontWeight: "normal",
                formatter: "",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
          // {
          //   name: "外边框",
          //   type: "pie",
          //   clockWise: false, //顺时加载
          //   hoverAnimation: false, //鼠标移入变大
          //   center: ["50%", "50%"],
          //   radius: ["90%", "70%"],
          //   label: {
          //     normal: {
          //       show: false,
          //     },
          //   },

          //   data: [
          //     {
          //       value: 0,
          //       name: "",
          //       itemStyle: {
          //         normal: {
          //           borderWidth: 0,
          //           borderColor: "#2985e0",
          //         },
          //       },
          //     },
          //   ],
          // },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    changebarOption(){
      this.barOptionthisweek.title.text =
        this.circleChartsData.lastweekmount +
        "/" +
        this.circleChartsData.thisweek;
      this.barOptionlastweek.title.text =
        this.circleChartsData.lastweekunsolve +
        "/" +
        this.circleChartsData.lastweeksolve;
      this.barOptionthisweek.series[0].data = [
        {
          value: this.circleChartsData.thisweek,
          name: "已解决",
        },
        { value: this.circleChartsData.lastweekmount, name: "待解决" },
      ];
      this.barOptionlastweek.series[0].data = [
        {
          value: this.circleChartsData.lastweeksolve,
          name: "已解决",
        },
        { value: this.circleChartsData.lastweekunsolve, name: "待解决" },
      ];
    },
    handleResize() {
      setTimeout( () => {
        this.$refs.chart1.resize();
        this.$refs.chart2.resize();
        let fontSize = this.$common.fitChartSize(18);
        this.barOptionthisweek.title.textStyle.fontSize = fontSize
        this.barOptionlastweek.title.textStyle.fontSize = fontSize
      }, 300)
    }
  },
  watch: {
    circleChartsData(){
      this.changebarOption();
    },
  }
};
</script>
<style lang="less" scoped>
.circle-section {
  padding: 13px 20px;
  padding-bottom: 0;
  .sec-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .sec-title {
    width: 100px;
    height: 36px;
    background: url("../../assets/images/airDataBoard/title_board.png")
      no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    .title {
      font-size: 18px;
      font-family: SourceHanSansCN;
      color: #26abff;
      font-weight: 550;
    }
  }
  .sec-status {
    display: flex;
    flex-direction: row;
    align-items: center;
    .status1 {
      display: flex;
      flex-direction: row;
      align-items: center;
      .greenDot {
        width: 8px;
        height: 8px;
        background: #7bd3c6;
        border-radius: 50%;
        margin-right: 4px;
      }
      .greenTxt {
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 550;
        color: #7bd3c6;
        margin-right: 15px;
      }
    }
    .status2 {
      display: flex;
      flex-direction: row;
      align-items: center;
      .redDot {
        width: 8px;
        height: 8px;
        background: #dd5252;
        border-radius: 50%;
        margin-right: 4px;
      }
      .redTxt {
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 550;
        color: #dd5252;
        margin-right: 15px;
      }
    }
  }
  .sec-content {
    background: linear-gradient(rgba(7, 17, 41, 0.8), rgba(19, 31, 54, 0.8));
    border-radius: 2px;
    padding: 20px 20px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .pie-chart {
      display: flex;
      flex-direction: column;
      align-items: center;
      .chart-sec {
        width: 110px;
        height: 110px;
      }
      .chart-txt {
        font-size: 16px;
        font-family: SourceHanSansCN;
        font-weight: 550;
        color: #ffffff;
        opacity: 0.5;
        margin-top: 10px;
      }
    }
  }
}
</style>

